import React from 'react';
import { BrainIcon } from 'lucide-react';
export function MethodSection() {
  return <section className="bg-amber-600 py-16 md:py-24 px-4 text-white" data-id="element-125">
      <div className="max-w-3xl mx-auto text-center" data-id="element-126">
        <div className="flex justify-center mb-6" data-id="element-127">
          <BrainIcon className="w-16 h-16 text-amber-100" data-id="element-128" />
        </div>
        <h2 className="font-serif text-3xl md:text-4xl font-bold mb-4" data-id="element-129">
          El Método ANCLA
        </h2>
        <h3 className="text-xl md:text-2xl font-medium text-amber-100 mb-8" data-id="element-130">
          Asociación de Nombres, Canciones y Lugares de Antaño
        </h3>
        <p className="text-lg md:text-xl leading-relaxed text-amber-50" data-id="element-131">
          Este sistema no le pide aprender cosas aburridas. Al contrario,
          utiliza sus recuerdos más profundos —boleros, refranes y vivencias—
          para crear "puentes" hacia la información nueva. Es neurociencia
          aplicada a nuestra cultura latina, activando zonas del cerebro que los
          métodos tradicionales ignoran.
        </p>
      </div>
    </section>;
}